import {EmployeesAPI} from "../api/EmployeesAPI";
import {AppStore} from "../desktop";
import {actionEmployeeFetchAllCompleted, actionEmployeeFetchCompleted} from "../store/employees/actions";
import {BaseService} from "./BaseService";
import {Employee} from "../models/Employee";
import {EmployeesActionTypes} from "../store/employees";
import {actionDeleteTabForItemId, actionSetTabItem, actionSetTabStateItem} from "../store/tabs/actions";
import {ErrorService} from "./ErrorService";
import {actionToastrInfo} from "../store/global";

export default class EmployeesService extends BaseService {

	static getAll() {

        let employeesAPI: EmployeesAPI = new EmployeesAPI()

		employeesAPI.getAll().then(EmployeesService.processResponse)
		.then((result) => actionEmployeeFetchAllCompleted(EmployeesService.fromAPIList(result)))
		.catch(error => ErrorService.handleError(error))
	}

    static getOne(employee: Employee) {

        let employeesAPI: EmployeesAPI = new EmployeesAPI()

        employeesAPI.get(employee).then(EmployeesService.processResponse).then(result => {
			actionEmployeeFetchCompleted(EmployeesService.fromAPIItem(result))
        }).catch(error => ErrorService.handleError(error))

    }

    static save(employee: Employee) {

        let employeesAPI: EmployeesAPI = new EmployeesAPI()

		if (employee.id) {
			employeesAPI.put(EmployeesService.itemToRequest(employee)).then(EmployeesService.processResponse).then(
				(data) => {
					AppStore.dispatch({
						type: EmployeesActionTypes.SAVE_COMPLETED, payload: EmployeesService.fromAPIItem(data)
					})
					actionToastrInfo("Info", "Podaci su uspešno snimljeni")
					actionSetTabStateItem(EmployeesService.fromAPIItem(data))
					actionSetTabItem(EmployeesService.fromAPIItem(data))
				}
			).catch(error => ErrorService.handleError(error))
		} else {

			employeesAPI.post(EmployeesService.itemToRequest(employee)).then(EmployeesService.processResponse).then(
				(data) => {
					AppStore.dispatch({
						type: EmployeesActionTypes.SAVE_COMPLETED, payload: EmployeesService.fromAPIItem(data)
					})
					actionToastrInfo("Info", "Podaci su uspešno snimljeni")
					actionSetTabStateItem(EmployeesService.fromAPIItem(data))
					actionSetTabItem(EmployeesService.fromAPIItem(data))
				}
			).catch(error => ErrorService.handleError(error))

		}

	}

	static delete(employee: Employee) {

        let employeesAPI: EmployeesAPI = new EmployeesAPI()

		employeesAPI.delete(EmployeesService.itemToRequest(employee)).then(EmployeesService.processResponse).then(
			(data) => {
				AppStore.dispatch({
					type: EmployeesActionTypes.DELETE_COMPLETED, payload: employee
				})
				actionToastrInfo("Info", "Podaci su uspešno obrisani")
				actionDeleteTabForItemId(employee.id)
			}
		).catch(error => ErrorService.handleError(error))
	}

	static deleteMultiple(employees: Employee[]) {

		let employeesAPI: EmployeesAPI = new EmployeesAPI()
		let count = 0;
		employees.forEach(employee => {

			employeesAPI.delete(EmployeesService.itemToRequest(employee)).then(EmployeesService.processResponse).then(
				(data) => {
					count++;
					actionDeleteTabForItemId(employee.id)
					actionToastrInfo("Info", "Podaci su uspešno obrisani")
					if(count === employees.length)
						AppStore.dispatch({
							type: EmployeesActionTypes.DELETE_MULTIPLE_COMPLETED, payload: employees
						})
				}
			).catch(error => ErrorService.handleError(error))
		});

	}

    static fromAPIList(apiList: any): Employee[] {
        const localList = apiList.map((apiItem: any) => EmployeesService.fromAPIItem(apiItem));
        //console.info('[fromAPIEmployeeList] converted employees: ', localList);
        return localList;
    }

    static fromAPIItem(apiItem: any): Employee{
        let employee = new Employee();

        employee.id = apiItem.id;
        employee.firstName = apiItem.firstName;
		employee.lastName = apiItem.lastName;
		employee.positionId = apiItem.positionId;
		employee.birthDate = apiItem.birthDate;
		employee.address = apiItem.address;
		employee.phone = apiItem.phone;
		employee.personalId = apiItem.personalId;
		employee.insuranceId = apiItem.insuranceId;
		employee.educationLevel = apiItem.educationLevel;
		employee.contractType = apiItem.contractType;
		employee.contractEndDate = apiItem.contractEndDate;
		employee.userId = apiItem.userId;

        return employee;
    }

    static itemToRequest (employee: Employee): any {

		let itemRequest: any = {};

		if(employee.id)
        itemRequest.id = employee.id;

		itemRequest.firstName = employee.firstName;
		itemRequest.lastName = employee.lastName;
		itemRequest.positionId = employee.positionId;
		itemRequest.birthDate = employee.birthDate;
		itemRequest.address = employee.address;
		itemRequest.phone = employee.phone;
		itemRequest.personalId = employee.personalId;
		itemRequest.insuranceId = employee.insuranceId;
		itemRequest.educationLevel = employee.educationLevel;
		itemRequest.contractType = employee.contractType;
		itemRequest.contractEndDate = employee.contractEndDate;
		itemRequest.userId = employee.userId;

		return itemRequest
	}

	static responseToItems (data: any) {
		return data
	}
}
